import type { CMSCardComponentDTO } from "../dto";
import { Card, styled } from "@mui/material";
import { renderCMSComponent } from "../componentFactory";

export type CMSCardComponentProps = Omit<CMSCardComponentDTO, "type"> & {
  className?: string;
};

export const CMSCardComponent = styled(
  ({ children, className, elevation = 0 }: CMSCardComponentProps) => {
    return (
      <StyledCard className={className} elevation={elevation}>
        {children.map((item, index) => renderCMSComponent(item, undefined, index))}
      </StyledCard>
    );
  },
  { shouldForwardProp: (prop) => prop !== "rootStyle" },
)<CMSCardComponentProps>(({ rootStyle }) => rootStyle);

const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));
